package com.mgacreative.hotel.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class Shift(
    val id: String = "",
    val tenant_id: String = "",
    val staff_id: String = "",
    val date: String = "",
    val start_time: String = "",
    val end_time: String = "",
    val role: String? = null,
    val status: String = "SCHEDULED"
)
